import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2fb561d9&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2fb561d9&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb561d9')) {
      api.createRecord('2fb561d9', component.options)
    } else {
      api.reload('2fb561d9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2fb561d9&", function () {
      api.rerender('2fb561d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/self-procurement-list/index.vue"
export default component.exports